module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAlklEQVRIx2MoijMQWqtNf8RwScBkQOwGWTwgdkMtpr/dCIvpbDeKxUA0JVkrdJs8HRC6xUD0Il/q/zkGWiMsFhNp98NtIERli4mxu7cIhKhvMR67L6xgMNNh4OYEISADyKWTxRC7IYA8W8kP6tm1DN0FIARk0DVxfTqMzqCCxQOTnQamABmYInNgKomBqRYHpiEwUE0fAJa30GCW3S6/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/st.png
// module id = 932
// module chunks = 0